export namespace IDayMonthYear {
  /**
   * Return an instance of IDayMonthYear with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IDayMonthYear>): IDayMonthYear =>
    ({
      ...(partial ?? {}),
    }) as IDayMonthYear;
}

/**
 * A proto representation of a LocalDate, which is timezone agnostic and represents a day in the calendar, rather
 * than a specific point in time.
 * Note: do not use this to represent events in time, for example, the exact start date of a promotional event, or the
 * exact time a preorder becomes ATS.
 * This is not equivalent to a timestamp. It is timezone agnostic and does not contain time information.
 */
export interface IDayMonthYear {
  /**
   * Calendar day of the month. eg March 1st => day = 1
   */
  day: number | undefined;
  /**
   * Calendar month of the year. eg March 1st => month = 3
   */
  month: number | undefined;
  /**
   * Calendar year
   */
  year: number | undefined;
}
